module.exports = __webpack_public_path__ + "img/ks_yama.067768fe.png";